import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userId: '',
  name: '',
  email: '',
  profileImage: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserIdEmail(state, action) {
      state.userId = action.payload.id;
      state.email = action.payload.email;
    },
    setUserProfile(state, action) {
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.profileImage = action.payload.profileImage;
    },
    clearUserProfile(state) {
      state.name = '';
      state.email = '';
      state.profileImage = '';
    },
  },
});

export const { setUserIdEmail, setUserProfile, clearUserProfile } = userSlice.actions;
export default userSlice.reducer;
